const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Validates Step 1 fields. Returns an object of field keys to error messages (empty string if valid).
 * All fields are required; email must be valid format.
 */
export function validateStep1(values) {
  const errors = {};

  if (values.active === undefined || values.active === null) {
    errors.active = "Povinné pole.";
  }

  const companyName = (values.companyName ?? "").trim();
  if (!companyName) errors.companyName = "Povinné pole.";

  const storeCode = (values.storeCode ?? "").trim();
  if (!storeCode) errors.storeCode = "Povinné pole.";

  const street = (values.street ?? "").trim();
  if (!street) errors.street = "Povinné pole.";

  const city = (values.city ?? "").trim();
  if (!city) errors.city = "Povinné pole.";

  const zip = (values.zip ?? "").toString().trim();
  if (!zip) {
    errors.zip = "Povinné pole.";
  } else if (!/^[\d\s]+$/.test(zip)) {
    errors.zip = "PSČ môže obsahovať len číslice a medzery.";
  }

  const country = values.country ?? "";
  if (!country) errors.country = "Povinné pole.";

  const firstName = (values.firstName ?? "").trim();
  if (!firstName) errors.firstName = "Povinné pole.";

  const lastName = (values.lastName ?? "").trim();
  if (!lastName) errors.lastName = "Povinné pole.";

  const email = (values.email ?? "").trim();
  if (!email) {
    errors.email = "Povinné pole.";
  } else if (!EMAIL_REGEX.test(email)) {
    errors.email = "Neplatný formát emailu.";
  }

  const phone = (values.phone ?? "").trim();
  if (!phone) errors.phone = "Povinné pole.";

  return errors;
}
